// extracted by mini-css-extract-plugin
module.exports = {"root":"page_root__1xfZq"};